import React from 'react'
import Footer from '../../navigation/Footer'
import { Link } from 'react-router-dom'
function Scaned() {
    return (
        <div>
            <Link to='/scanedlocation'>view market location</Link>
            <Footer/>
            </div>
    )
}

export default Scaned